import type { Prototype } from "../prototype-types";

export const amyJinPrototypes: Prototype[] = [
  {
    id: "search-continuous-browsing",
    name: "Search Continuous Browsing",
    path: "/aj/search-continuous-browsing",
    description:
      "Search results grid with product tiles featuring image carousels, filter pills, bestseller badges, and quick-add functionality for continuous browsing.",
    owner: "AmyJin",
    createdAt: "2026-02-03",
    lastUpdated: "2026-02-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/94d85282aa5d0caeb03ca5585da199b7393f51e5e13781700e5f7d5f64dd3d55.png",
    creationTool: "cursor",
  },
];
